import { splitMeta, recombine, stageMeta } from './check-effect.js';
/**
 * row_check: condition-based, per-row (P2b). Sibling of {@link crossFieldCheck}
 * but the condition is evaluated PER LINE-ITEM ROW (see `evaluateRowCheck` in
 * rule-runtime) rather than once over the doc's fields. Always form scope; the
 * `condition` is REQUIRED at author time (the editor enforces it), and the
 * type-config carries `rowGroup` (mandatory) + `highlightColumn` (optional) via
 * {@link RowCheckConfig}. No fieldRef — the failure is surfaced on a line-item
 * cell, not a doc field.
 */
export const rowCheck = {
    compile: (step) => {
        const { name, stage, stages, severity, overrideBehavior, overrideConfig, rest } = splitMeta(step.config);
        return {
            name, type: 'rowCheck', scope: 'form', trigger: 'on-validate',
            ...stageMeta({ stage, stages }),
            severity, overrideBehavior, overrideConfig,
            config: rest, condition: step.condition,
        };
    },
    parse: (payload) => {
        if (!payload || typeof payload !== 'object')
            return null;
        const rule = payload;
        if (rule.type !== 'rowCheck')
            return null;
        return {
            effectKey: 'row_check', moment: 'on_validate', scope: 'form',
            condition: rule.condition,
            config: recombine(rule, rule.config ?? {}),
        };
    },
};
//# sourceMappingURL=row-check-effect.js.map